import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";
import PageContext from "../../../context";

const PackagesBreakDownChart = () => {
  const { packageBreakdown } = React.useContext(PageContext);
  const { packagesList = {}, total = {} } = packageBreakdown;
  return (
    <Paper className="real-time-kpi-stat-table-root" elevation={0}>
      <TableContainer>
        <Table className="pricing-breakdown-chart">
          <TableHead>
            <TableRow>
              <TableCell>Package</TableCell>
              <TableCell align="center">Category</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">Card</TableCell>
              <TableCell align="right">Cash</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(packagesList).map(([key, value]) => (
              <>
                <TableRow>
                  <TableCell rowSpan={3} className="operator-name">
                    {key}
                  </TableCell>
                  <TableCell align="center">New</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right">{value.new?.card}</TableCell>
                  <TableCell align="right">{value.new?.cash}</TableCell>
                  <TableCell align="right">
                    {(value.new?.card ?? 0) + (value.new?.cash ?? 0)}
                  </TableCell>
                  <></>
                </TableRow>
                <TableRow>
                  <TableCell align="center">Renew</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right">{value.renew?.card}</TableCell>
                  <TableCell align="right">{value.renew?.cash}</TableCell>
                  <TableCell align="right">
                    {(value.renew?.card ?? 0) + (value.renew?.cash ?? 0)}
                  </TableCell>
                </TableRow>
                <TableRow className="package-total-row">
                  <TableCell align="center">Total</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right">{value.total?.card}</TableCell>
                  <TableCell align="right">{value.total?.cash}</TableCell>
                  <TableCell align="right">
                    {(value.total?.card ?? 0) + (value.total?.cash ?? 0)}
                  </TableCell>
                </TableRow>
              </>
            ))}
            <TableRow className="grand-total-row">
              <TableCell align="left">Total</TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
              <TableCell align="right">{total?.card ?? 0}</TableCell>
              <TableCell align="right">{total?.cash ?? 0}</TableCell>
              <TableCell align="right">
                {(total?.card ?? 0) + (total?.cash ?? 0)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PackagesBreakDownChart;
